import styles from "./Version.module.scss";
import SVG from "react-inlinesvg";

import PackageJson from "../../../../package.json";
import { api } from "../../../app/conf";
import { certifiedSVG, testingSVG } from "../../../shared/helpers/icons";
import { Text } from "../../../shared/components";
import {
  FONT_COLOR,
  FONT_SIZE,
  LINE_CLAMP,
} from "../../../shared/components/Text/types";

export default function Version(versionProps) {
  const { collapsed } = versionProps;
  const version = PackageJson.version;

  return (
    <div className={styles.container} data-collapsed={collapsed}>
      {api.includes("test") && <SVG src={testingSVG}  className={styles.versionIcon} />}
      <Text
        value={`Version ${version}`}
        fontSize={FONT_SIZE.MINIMUN}
        lineClamp={LINE_CLAMP.LINE_CLAMP_1}
        fontColor={FONT_COLOR.OTHERS.WHITE}
      />
    </div>
  );
}
